module.exports = __webpack_public_path__ + "static/media/phonecall.4db5d648.svg";